var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRec02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3283 8.5608L32.8526 3.28848L3.22635 0.521504L7.70127 5.79375L37.3283 8.5608Z",
    fill: "url(#paint0_linear_191_10)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3283 8.5608L32.8526 3.28848L3.22635 0.521504L7.70127 5.79375L37.3283 8.5608Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09035 35.476L0.53927 30.1148L3.15971 0.521636L7.71072 5.88361L5.09035 35.476Z",
    fill: "url(#paint1_linear_191_10)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09035 35.476L0.53927 30.1148L3.15971 0.521636L7.71072 5.88361L5.09035 35.476Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.308 8.67554L7.59253 5.86578L5.00426 35.3598L34.7197 38.1695L37.308 8.67554Z",
    fill: "url(#paint2_linear_191_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_10",
    x1: 17.2369,
    y1: 0.959973,
    x2: 27.6886,
    y2: 13.7415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_191_10",
    x1: -1.97125,
    y1: 22.984,
    x2: 14.6878,
    y2: 8.84223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_191_10",
    x1: 20.2366,
    y1: 32.4913,
    x2: 22.5255,
    y2: 8.28445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C21C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73174C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRec02);
export default __webpack_public_path__ + "static/media/Rec-02.7be4845f0229c2085f8de530e764ae82.svg";
export { ForwardRef as ReactComponent };